// Imports

import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { SubcategoriesComponent } from './subcategories/subcategories.component';
import { QuestionsComponent } from './questions/questions.component';
import { MyProfileComponent } from './my-profile/my-profile.component';

// Route Configuration
export const routes: Routes = [
	{ path: '', component: DashboardComponent },
	{ path: 'dashboard', component: DashboardComponent },
	{ path: 'login', component: LoginComponent },
    { path: 'subcategories', component: SubcategoriesComponent },
    { path: 'questions/:category', component: QuestionsComponent },
    { path: 'my-profile', component: MyProfileComponent },
];


export const routing: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// d:/xampp/htdocs/zenith-admin/src/app/app.routes.ts